import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";

export const useGetSystemFolders = () => {
    return useQuery<SystemFolder[]>({
        queryKey: ["/api/v1/admin/systemFolders"],
        queryFn: () => get<SystemFolder[]>("/api/v1/admin/systemFolders"),
    });
};

export interface SystemFolder {
    name: string;
    path: string;
    folders: SystemFolder[];
}
